export default {
  country: 'Land',
  language: 'Taal',
  currency: 'Valuta',
}
